import React from "react";
export default function UserDashboard() {
    return (
        <div className="dashboard-summary">
            <div className="summary-card">
                <h3>12</h3>
                <p>Total Orders</p>
            </div>
            <div className="summary-card">
                <h3>2</h3>
                <p>Pending Orders</p>
            </div>
            <div className="summary-card">
                <h3>4</h3>
                <p>Wishlist Items</p>
            </div>
            <div className="summary-card">
                <h3>3</h3>
                <p>Saved Address</p>
            </div>
        </div>
    )
}